import { z } from "zod";

export const addGuestFormSchema = z.object({
  firstName: z.string().min(1, "first-name-required"),
  lastName: z.string().min(1, "last-name-required"),
  email: z.string().email("invalid-email"),
  phone: z.string().min(5, "phone-required"),
  gender: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .refine(
      (data) => {
        if (data.value === "") {
          return false;
        }
        return true;
      },
      {
        message: "select-gender",
      },
    ),
});
